<template>
    <section class="video-fullscreen">
        <div class="video grayscale" data-overlay-dark="5">
            <div class="desgradado"></div>
        <video playsinline autoplay loop muted aria-label="Background Video">
            <source :src="workVideoBanner" type="video/mp4">
            <!-- Fallback for unsupported formats -->
            Your browser does not support HTML5 video.
        </video>
        
        </div>
        <div class="v-middle">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 mt-60">
                        <h4 class="hZUCZe">{{ $t('Explore projects that transform ideas into solutions') }}</h4>
                        <h1 class="mb-10 text-h2-sans">{{ $t('Our Work, Your Success') }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="works bg-drk">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="item">
                        <div class="wrap img-grayscale">
                            <div class="img img-grayscale"> <img :src="work4" class="img-fluid"> </div>
                            <div class="text">
                                <a href="#">
                                    <h4>{{ $t('Development') }}</h4>
                                    <p>{{ $t('Web Design') }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="item">
                        <div class="wrap img-grayscale">
                            <div class="img img-grayscale"> <img :src="work1" class="img-fluid"> </div>
                            <div class="text">
                                <a href="#">
                                    <h4>{{ $t('Audio Visual') }}</h4>
                                    <p>{{ $t('Production') }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="item">
                        <div class="wrap img-grayscale">
                            <div class="img img-grayscale"> <img :src="work2" class="img-fluid"> </div>
                            <div class="text">
                                <a href="#">
                                    <h4>{{ $t('Electronic Commerce') }}</h4>
                                    <p>{{ $t('Platforms') }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <LetstalkComponent />
</template>

<script>
import workVideoBanner from '@/assets/videos/video_service5.mp4'
import work1 from '@/assets/work/1.jpg'
import work2 from '@/assets/work/2.jpg'
import work3 from '@/assets/work/3.jpg'
import work4 from '@/assets/work/4.jpg'
import work5 from '@/assets/work/5.jpg'
import work6 from '@/assets/work/6.jpg' 
import LetstalkComponent from '@/components/LetstalkComponent.vue'
export default {
    name: 'WorksPage',
    components: {
        LetstalkComponent
    },
    data() {
        return {
            workVideoBanner,
            work1,
            work2,
            work3,
            work4,
            work5,
            work6,
        };
    },
}
</script>
<style scoped>
.video-fullscreen {
    overflow: hidden;
  }
  .video-fullscreen .video.grayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
  }
.video-fullscreen .video {
    height: 100vh;
}
.video-fullscreen video {
    width: 100vw;
    min-width: 100%;
    height: 100vh;
    -o-object-fit: cover;
    object-fit:cover;
}

.v-middle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    -webkit-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    z-index: 9;
}

/* ======= Works style ======= */
.works {
    overflow: hidden;
}
.works .item {
    margin-bottom: 25px;
}
.works .item .wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
}
.works .item .wrap .img {
  position: relative;
  background-color: #000;
  transition: 700ms cubic-bezier(0.17, 0.67, 0, 1.01);
  border-radius: 10px;
}
.works .item .wrap .img img {
  width: 100%;
  margin: 0;
  transition: 700ms cubic-bezier(0.17, 0.67, 0, 1.01);
  background-size: cover;
  border-radius: 10px;
}
.works .item .wrap:hover img {
  opacity: 0.2;
}
.works .item .wrap:hover .img {
  transform: scale(0.95);
}
.works .item .wrap:hover .text {
  opacity: 1;
  transform: translateX(0px);
}
.works .item .wrap .text {
  position: absolute;
  opacity: 0;
  transform: translateX(-20px);
  transition: 700ms cubic-bezier(0.17, 0.67, 0, 1.01);
  padding: 15px;
}
.works .item .wrap .text h4 {
    font-size: 24px;
    margin-bottom: 5px;
    color: #fff;
}
.works .item .wrap .text p {
    font-size: 20px;
    color: #ed1b24;
    margin-bottom: 0;
    font-weight: 400;
}
/* icon box button */
.works .item .wrap .text .icon-box {
  position: relative;
  display: block;
}
.works .item .wrap .text a .icon-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    transition: all 200ms linear;
    transition-delay: 0.3s;
    z-index: 1;
    margin: 0 auto;
}
.works .item .wrap .text a .icon-box::before {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #ed1b24;
  background: #ed1b24;
  border-radius: 50%;
  transform: scale(0.7);
  opacity: 0;
  -webkit-transition: all 0.4s linear;
  -o-transition: all 0.4s linear;
  transition: all 0.4s linear;
  z-index: 1;
  content: "";
}
.works .item:hover .wrap .text a .icon-box::before {
  transform: scale(1.0);
  opacity: 1;
}
.works .item .wrap .text a .icon-box i::before {
  position: relative;
  display: inline-block;
  color: #fff;
  font-size: 24px;
  -webkit-transform: rotate(-40deg);
  transform: rotate(-40deg);
  -webkit-transition: all 0.4s linear;
  -o-transition: all 0.4s linear;
  transition: all 0.4s linear;
}
.works .item:hover .wrap .text a .icon-box i::before {
    transform: rotate(0);
    color: #fff;
    z-index: 9;
}
/* btn-1 */
.works .item:hover .wrap .text .btn-1 i {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transition: all 0.4s linear;
    -o-transition: all 0.4s linear;
    transition: all 0.4s linear;
}
.works .item:hover .wrap .text.btn-1:hover i {
    transform: rotate(0);
}
</style>